import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IUser from '../../_interfaces/IUser';

@Injectable({
  providedIn: 'root',
})
export class UsersSettingsService {
  constructor(private http: HttpClient) {}

  updateInfo(users_id: number, user: Partial<IUser>) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/users/${users_id}/settings/info`,
      user
    );
  }

  updatePassword(users_id: number, password: string) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/users/${users_id}/settings/password`,
      { password }
    );
  }
}
